import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import {
    affIds,
    BET,
    buildTransferLink,
    dcmpTags
} from '../../helpers/transfers';
import { checkIfExcludedFrom } from '../../utils/authUtils';
import { useFeatures } from '../../hooks/useFeatures';
import { useAuth } from '../../hooks/useAuth';

export const CrossSellBarContainer = () => {
    const { features } = useFeatures();
    const { authStore } = useAuth();

    const displayBettingLinks = get(features, 'betting_links_enabled', false);

    const showCrossSellBar = () => {
        return displayBettingLinks && !checkIfExcludedFrom('bet');
    };

    return (
        <CrossSellBar
            showCrossSellBar={showCrossSellBar()}
            isLoggedIn={authStore.loggedIn}
        />
    );
};

export const CrossSellBar = ({ showCrossSellBar, isLoggedIn }) => {
    if (showCrossSellBar) {
        const transferLink = buildTransferLink({
            to: BET,
            dcmp: dcmpTags.mastHead,
            affId: affIds.masthead,
            isLoggedIn
        });

        return (
            <Styled.Wrapper>
                <Styled.CrossSellLink href={transferLink}>
                    Bet with
                    <Styled.CrossSellImg
                        alt="skybet"
                        src="/img/logos/skybet-secondary.png"
                    />
                </Styled.CrossSellLink>
            </Styled.Wrapper>
        );
    }
    return <></>;
};

CrossSellBar.propTypes = {
    showCrossSellBar: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};

export default CrossSellBarContainer;
